window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
window.MG_SWATCH_SETS["Colors-WNK08ttop"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 6,
      "product_image_padding": 3,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 8,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 4,
      "product_image_padding": 1,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "more_popup_text": "More",
      "margin_top": 0,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-WWSH-_-TPLQM-wBox-Tabletop_1333x.png?v=1784052401",
          "product_url": "/products/tabletopkit_white-wash_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_white-wash_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-WOAK-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054534",
          "product_url": "/products/tabletopkit_white-oak_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_white-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-FOAK-_-TPLQM-wBox-Tabletop_1333x.png?v=1784052513",
          "product_url": "/products/tabletopkit_french-oak_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_french-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-MWAL-Swatch-Rustic-Small.jpg?v=1777021282",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-MWAL-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054800",
          "product_url": "/products/tabletopkit_modern-walnut_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_modern-walnut_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-DOAK-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054906",
          "product_url": "/products/tabletopkit_dark-oak_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_dark-oak_s_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "more_popup_text": "More",
      "margin_top": 20,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-SBCH-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054378",
          "product_url": "/products/tabletopkit_sun-bleached_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_sun-bleached_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-POAK-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054684",
          "product_url": "/products/tabletopkit_pickled-oak_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_pickled-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-BARN-_-TPLQM-wBox-Tabletop_1333x.png?v=1784052960",
          "product_url": "/products/tabletopkit_barn-wood_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_barn-wood_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-BWAL-_-TPLQM-wBox-Tabletop_1333x.png?v=1784052247",
          "product_url": "/products/tabletopkit_black-walnut_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_black-walnut_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_appearance_source": "custom",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#000000",
          "preset_button_border_size": 20,
          "preset_button_shadow_size": 0,
          "preset_button_border_radius_px": 12,
          "preset_button_background_color": "#ffffff",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#ffffff",
          "preset_button_gradient_angle": 180,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 0,
          "preset_button_text_size_desktop": 0,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 12,
          "preset_button_product_image_padding": 0,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-WETH-_-TPLQM-wBox-Tabletop_1333x.png?v=1784053137",
          "product_url": "/products/tabletopkit_weathered-wood_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_weathered-wood_s_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 20,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-DRIW-_-TPLQM-wBox-Tabletop_1333x.png?v=1784052751",
          "product_url": "/products/tabletopkit_drift-wood_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_drift-wood_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-CEDR-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054096",
          "product_url": "/products/tabletopkit_cedar_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_cedar_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-CHRY-_-TPLQM-wBox-Tabletop_1333x.png?v=1784053410",
          "product_url": "/products/tabletopkit_vintage-cherry_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_vintage-cherry_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-JAVA-_-TPLQM-wBox-Tabletop_1333x.png?v=1784053724",
          "product_url": "/products/tabletopkit_java_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_java_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-RMGY-_-TPLQM-wBox-Tabletop_1333x.png?v=1784053827",
          "product_url": "/products/tabletopkit_red-mahogany_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_red-mahogany_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-OOAK-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054229",
          "product_url": "/products/tabletopkit_old-oak_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_old-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-PECA-TPLQM-wBox-Tabletop_b843de5f-5b2e-40a6-83c1-0f6cbb8b0f3b_1333x.png?v=1778530683",
          "product_url": "/products/tabletopkit_pecan_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_pecan_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-CHAR-_-TPLQM-wBox-Tabletop_1333x.png?v=1784053272",
          "product_url": "/products/tabletopkit_charcoal_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_charcoal_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-CBLK-_-TPLQM-wBox-Tabletop_1333x.png?v=1784053587",
          "product_url": "/products/tabletopkit_classic-black_s_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_classic-black_s_tripletique",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK16ttop"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 6,
      "product_image_padding": 3,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 8,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 4,
      "product_image_padding": 1,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "corner_radius_px": 6,
    "match_settings_preset_key": "Colors-WNK08ttop"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "more_popup_text": "More",
      "margin_top": 0,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-WWSH-TPLQM-wBox-Tabletop_6138bae0-d1d0-4442-8310-9abbfe430f9f_1333x.png?v=1778526715",
          "product_url": "/products/tabletopkit_white-wash_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_white-wash_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-WOAK-TPLQM-wBox-Tabletop_20ae3e93-caf8-417d-bc5f-b1e9305e41a2_1333x.png?v=1778524096",
          "product_url": "/products/tabletopkit_white-oak_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_white-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-FOAK-TPLQM-wBox-Tabletop_f44ca737-9bfb-46bf-be87-eb79070102ae_1333x.png?v=1777395062",
          "product_url": "/products/tabletopkit_french-oak_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_french-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-MWAL-Swatch-Rustic-Small.jpg?v=1777021282",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-BARN-wBox-Tabletop_1333x.png?v=1774975475",
          "product_url": "/products/tabletopkit_modern-walnut_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_modern-walnut_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-DOAK-TPLQM-wBox-Tabletop_4acaedb9-fb54-4725-990c-1da53e14dd41_1333x.png?v=1778525983",
          "product_url": "/products/tabletopkit_dark-oak_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_dark-oak_m_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "more_popup_text": "More",
      "margin_top": 20,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-SBCH-TPLQM-wBox-Tabletop_5c598422-0cbc-424d-a7fd-47d4cca12fa1_1333x.png?v=1778523524",
          "product_url": "/products/tabletopkit_sun-bleached_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_sun-bleached_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-POAK-TPLQM-wBox-Tabletop_3b0ca654-f1f8-4f79-a0b0-619f63922085_1333x.png?v=1778524831",
          "product_url": "/products/tabletopkit_pickled-oak_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_pickled-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-BARN-TPLQM-wBox-Tabletop_0a37a0ef-7fa2-4bb8-ba51-019f7f8b3dc6_1333x.png?v=1777566640",
          "product_url": "/products/tabletopkit_barn-wood_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_barn-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-BWAL-TPLQM-wBox-Tabletop_840d64d2-7a02-4183-ae45-c580470a9b29_1333x.png?v=1778526383",
          "product_url": "/products/tabletopkit_black-walnut_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_black-walnut_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_appearance_source": "custom",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#000000",
          "preset_button_border_size": 20,
          "preset_button_shadow_size": 0,
          "preset_button_border_radius_px": 12,
          "preset_button_background_color": "#ffffff",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#ffffff",
          "preset_button_gradient_angle": 180,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 0,
          "preset_button_text_size_desktop": 0,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 12,
          "preset_button_product_image_padding": 0,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-WETH-TPLQM-wBox-Tabletop_05d87cf3-131d-448f-811e-a4f3eacea9af_1333x.png?v=1778527538",
          "product_url": "/products/tabletopkit_weathered-wood_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_weathered-wood_m_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 20,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-DRIW-TPLQM-wBox-Tabletop_c13f7841-d460-460e-ab59-f8fba81d40c3_1333x.png?v=1778527243",
          "product_url": "/products/tabletopkit_drift-wood_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_drift-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-CEDR-TPLQM-wBox-Tabletop_72adac4a-d5ae-456a-948f-31d56089eb9d_1333x.png?v=1778529924",
          "product_url": "/products/tabletopkit_cedar_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_cedar_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-CHRY-TPLQM-wBox-Tabletop_f2e8ab58-177f-42b0-be33-962ae74d8b76_1333x.png?v=1778528262",
          "product_url": "/products/tabletopkit_vintage-cherry_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_vintage-cherry_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-JAVA-TPLQM-wBox-Tabletop_70a0106c-980e-4064-ab0d-674f282f96a5_1333x.png?v=1778529027",
          "product_url": "/products/tabletopkit_java_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_java_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-RMGY-TPLQM-wBox-Tabletop_0c559f8b-4265-4fc9-81fb-85c440f58569_1333x.png?v=1778529589",
          "product_url": "/products/tabletopkit_red-mahogany_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_red-mahogany_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-OOAK-TPLQM-wBox-Tabletop_251edbfd-a0be-44bf-ac0e-866a67df7edf_1333x.png?v=1778530573",
          "product_url": "/products/tabletopkit_old-oak_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_old-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-PECA-TPLQM-wBox-Tabletop_173f4470-8da2-448a-81f7-60e9cbe74eef_1333x.png?v=1778530765",
          "product_url": "/products/tabletopkit_pecan_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_pecan_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-CHAR-TPLQM-wBox-Tabletop_e65a6cc5-fd67-4132-b8ff-8240a66f688f_1333x.png?v=1778527949",
          "product_url": "/products/tabletopkit_charcoal_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_charcoal_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-CBLK-TPLQM-wBox-Tabletop_4c003bdc-4612-4b12-91dd-c227fabaaa97_1333x.png?v=1778528718",
          "product_url": "/products/tabletopkit_classic-black_m_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_classic-black_m_tripletique",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-WNK32ttop"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 6,
      "product_image_padding": 3,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 8,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 4,
      "product_image_padding": 1,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "corner_radius_px": 6,
    "match_settings_preset_key": "Colors-WNK08ttop"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "more_popup_text": "More",
      "margin_top": 0,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_white-wash.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-WWSH-TPLQ-Matte-onTable_ff29f729-1bcb-41aa-a599-dae17c953fe0_1333x.png?v=1778526846",
          "product_url": "/products/tabletopkit_white-wash_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_white-wash_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-WOAK-Swatch-Rustic-Small.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-WOAK-TPLQM-wBox-Tabletop_761930c8-f8a5-4751-89e9-af3b18e58e39_1333x.png?v=1778592537",
          "product_url": "/products/tabletopkit_white-oak_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_white-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "French Oak",
          "alt": "French Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_french-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-FOAK-TPLQM-wBox-Tabletop_95673e04-7776-4c25-9c13-c13b4337a589_1333x.png?v=1777395251",
          "product_url": "/products/tabletopkit_french-oak_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_french-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Modern Walnut",
          "alt": "Modern Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/RQ-WNK-MWAL-Swatch-Rustic-Small.jpg?v=1777021282",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-BARN-wBox-Tabletop_1333x.png?v=1774990573",
          "product_url": "/products/tabletopkit_modern-walnut_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_modern-walnut_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_dark-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-DOAK-TPLQM-wBox-Tabletop_4703297b-d55c-493c-948a-377780eecf5c_1333x.png?v=1778526097",
          "product_url": "/products/tabletopkit_dark-oak_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_dark-oak_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>More Favorites</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "more_popup_text": "More",
      "margin_top": 20,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Sun Bleached",
          "alt": "Sun Bleached",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_sun-bleached.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-SBCH-TPLQM-wBox-Tabletop_a6ae4a74-983f-4dcc-b99d-f008ded5e436_1333x.png?v=1778523682",
          "product_url": "/products/tabletopkit_sun-bleached_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_sun-bleached_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pickled Oak",
          "alt": "Pickled Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pickled-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-POAK-TPLQM-wBox-Tabletop_792ec011-1df3-4aab-886c-178cf6db7dcc_1333x.png?v=1778525111",
          "product_url": "/products/tabletopkit_pickled-oak_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_pickled-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_barn-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-BARN-TPLQM-wBox-Tabletop_7a84f555-ca55-4398-bfcf-d495f97ab04c_1333x.png?v=1778525589",
          "product_url": "/products/tabletopkit_barn-wood_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_barn-wood_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_black-walnut.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-BWAL-TPLQM-wBox-Tabletop_14703fb6-1882-4f69-a0b9-5151c6d16a50_1333x.png?v=1778526484",
          "product_url": "/products/tabletopkit_black-walnut_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_black-walnut_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_appearance_source": "custom",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#000000",
          "preset_button_border_size": 20,
          "preset_button_shadow_size": 0,
          "preset_button_border_radius_px": 12,
          "preset_button_background_color": "#ffffff",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#ffffff",
          "preset_button_gradient_angle": 180,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 0,
          "preset_button_text_size_desktop": 0,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 12,
          "preset_button_product_image_padding": 0,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "Fan arrangement of Retique It® wood finish swatches featuring white wash, dark walnut, weathered gray, golden oak, and natural light wood tones with visible grain patterns.",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_weathered-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-WETH-TPLQM-wBox-Tabletop_d41a26b8-9519-4109-873e-5306abf64165_1333x.png?v=1778527626",
          "product_url": "/products/tabletopkit_weathered-wood_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_weathered-wood_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 20,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Drift Wood",
          "alt": "Drift Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_drift-wood.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-DRIW-TPLQM-wBox-Tabletop_b1cb1f39-8184-40f4-8a1e-458f7c0644ed_1333x.png?v=1778527319",
          "product_url": "/products/tabletopkit_drift-wood_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_drift-wood_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cedar",
          "alt": "Cedar",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_cedar.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-CEDR-TPLQM-wBox-Tabletop_3612cc0a-0a1c-4592-9f4a-8751758959d7_1333x.png?v=1778530050",
          "product_url": "/products/tabletopkit_cedar_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_cedar_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Vintage Cherry",
          "alt": "Vintage Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_vintage-cherry.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-CHRY-TPLQM-wBox-Tabletop_873d023a-a4f9-4451-b5bf-9129a5c30b62_1333x.png?v=1778528452",
          "product_url": "/products/tabletopkit_vintage-cherry_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_vintage-cherry_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_java.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-JAVA-TPLQM-wBox-Tabletop_2fbd7be8-eff7-4a51-81a6-404c36aebaf1_1333x.png?v=1778529124",
          "product_url": "/products/tabletopkit_java_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_java_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_red-mahogany.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-RMGY-TPLQM-wBox-Tabletop_354387b3-a866-4dde-bea4-d68e436cc3f9_1333x.png?v=1778529705",
          "product_url": "/products/tabletopkit_red-mahogany_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_red-mahogany_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_old-oak.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-OOAK-TPLQM-wBox-Tabletop_dacb12ff-60c6-40bd-bcb8-1084a1b5302c_1333x.png?v=1778530475",
          "product_url": "/products/tabletopkit_old-oak_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_old-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Pecan",
          "alt": "Dark Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_pecan.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-PECA-TPLQM-wBox-Tabletop_12e12332-52f1-4879-baf5-952253f9d043_1333x.png?v=1778530845",
          "product_url": "/products/tabletopkit_pecan_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_pecan_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_charcoal.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-CHAR-TPLQM-wBox-Tabletop_97a28f45-505f-40f3-800a-1e00f398ea65_1333x.png?v=1778528037",
          "product_url": "/products/tabletopkit_charcoal_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_charcoal_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Rustic-Small-woodnfinish_classic-black.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-CBLK-TPLQM-wBox-Tabletop_1bdc2656-9608-49a4-afca-6a845fbb89b9_1333x.png?v=1778528825",
          "product_url": "/products/tabletopkit_classic-black_l_tripletique",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_classic-black_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-SBCH"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-SBCH-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054378",
          "product_url": "/products/tabletopkit_sun-bleached_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_sun-bleached_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-SBCH-TPLQM-wBox-Tabletop_5c598422-0cbc-424d-a7fd-47d4cca12fa1_1333x.png?v=1778523524",
          "product_url": "/products/tabletopkit_sun-bleached_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_sun-bleached_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-SBCH-TPLQM-wBox-Tabletop_a6ae4a74-983f-4dcc-b99d-f008ded5e436_1333x.png?v=1778523682",
          "product_url": "/products/tabletopkit_sun-bleached_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_sun-bleached_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-WWSH"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-WWSH-_-TPLQM-wBox-Tabletop_1333x.png?v=1784052401",
          "product_url": "/products/tabletopkit_white-wash_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_white-wash_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-WWSH-TPLQM-wBox-Tabletop_6138bae0-d1d0-4442-8310-9abbfe430f9f_1333x.png?v=1778526715",
          "product_url": "/products/tabletopkit_white-wash_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_white-wash_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-WWSH-TPLQ-Matte-onTable_ff29f729-1bcb-41aa-a599-dae17c953fe0_1333x.png?v=1778526846",
          "product_url": "/products/tabletopkit_white-wash_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_white-wash_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-WOAK"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-WOAK-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054534",
          "product_url": "/products/tabletopkit_white-oak_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_white-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-WOAK-TPLQM-wBox-Tabletop_20ae3e93-caf8-417d-bc5f-b1e9305e41a2_1333x.png?v=1778524096",
          "product_url": "/products/tabletopkit_white-oak_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_white-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-WOAK-TPLQM-wBox-Tabletop_761930c8-f8a5-4751-89e9-af3b18e58e39_1333x.png?v=1778592537",
          "product_url": "/products/tabletopkit_white-oak_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_white-oak_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-POAK"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-POAK-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054684",
          "product_url": "/products/tabletopkit_pickled-oak_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_pickled-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-POAK-TPLQM-wBox-Tabletop_3b0ca654-f1f8-4f79-a0b0-619f63922085_1333x.png?v=1778524831",
          "product_url": "/products/tabletopkit_pickled-oak_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_pickled-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-POAK-TPLQM-wBox-Tabletop_792ec011-1df3-4aab-886c-178cf6db7dcc_1333x.png?v=1778525111",
          "product_url": "/products/tabletopkit_pickled-oak_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_pickled-oak_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-BARN"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-BARN-_-TPLQM-wBox-Tabletop_1333x.png?v=1784052960",
          "product_url": "/products/tabletopkit_barn-wood_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_barn-wood_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-BARN-TPLQM-wBox-Tabletop_0a37a0ef-7fa2-4bb8-ba51-019f7f8b3dc6_1333x.png?v=1777566640",
          "product_url": "/products/tabletopkit_barn-wood_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_barn-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-BARN-TPLQM-wBox-Tabletop_7a84f555-ca55-4398-bfcf-d495f97ab04c_1333x.png?v=1778525589",
          "product_url": "/products/tabletopkit_barn-wood_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_barn-wood_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-DOAK"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-DOAK-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054906",
          "product_url": "/products/tabletopkit_dark-oak_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_dark-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-DOAK-TPLQM-wBox-Tabletop_4acaedb9-fb54-4725-990c-1da53e14dd41_1333x.png?v=1778525983",
          "product_url": "/products/tabletopkit_dark-oak_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_dark-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-DOAK-TPLQM-wBox-Tabletop_4703297b-d55c-493c-948a-377780eecf5c_1333x.png?v=1778526097",
          "product_url": "/products/tabletopkit_dark-oak_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_dark-oak_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-BWAL"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-BWAL-_-TPLQM-wBox-Tabletop_1333x.png?v=1784052247",
          "product_url": "/products/tabletopkit_black-walnut_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_black-walnut_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-BWAL-TPLQM-wBox-Tabletop_840d64d2-7a02-4183-ae45-c580470a9b29_1333x.png?v=1778526383",
          "product_url": "/products/tabletopkit_black-walnut_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_black-walnut_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-BWAL-TPLQM-wBox-Tabletop_14703fb6-1882-4f69-a0b9-5151c6d16a50_1333x.png?v=1778526484",
          "product_url": "/products/tabletopkit_black-walnut_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_black-walnut_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-MWAL"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-MWAL-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054800",
          "product_url": "/products/tabletopkit_modern-walnut_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_modern-walnut_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-BARN-wBox-Tabletop_1333x.png?v=1774975475",
          "product_url": "/products/tabletopkit_modern-walnut_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_modern-walnut_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-BARN-wBox-Tabletop_1333x.png?v=1774990573",
          "product_url": "/products/tabletopkit_modern-walnut_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_modern-walnut_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-FOAK"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-FOAK-_-TPLQM-wBox-Tabletop_1333x.png?v=1784052513",
          "product_url": "/products/tabletopkit_french-oak_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_french-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-FOAK-TPLQM-wBox-Tabletop_f44ca737-9bfb-46bf-be87-eb79070102ae_1333x.png?v=1777395062",
          "product_url": "/products/tabletopkit_french-oak_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_french-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-FOAK-TPLQM-wBox-Tabletop_95673e04-7776-4c25-9c13-c13b4337a589_1333x.png?v=1777395251",
          "product_url": "/products/tabletopkit_french-oak_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_french-oak_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-DRIW"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-DRIW-_-TPLQM-wBox-Tabletop_1333x.png?v=1784052751",
          "product_url": "/products/tabletopkit_drift-wood_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_drift-wood_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-DRIW-TPLQM-wBox-Tabletop_c13f7841-d460-460e-ab59-f8fba81d40c3_1333x.png?v=1778527243",
          "product_url": "/products/tabletopkit_drift-wood_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_drift-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-DRIW-TPLQM-wBox-Tabletop_b1cb1f39-8184-40f4-8a1e-458f7c0644ed_1333x.png?v=1778527319",
          "product_url": "/products/tabletopkit_drift-wood_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_drift-wood_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-WETH"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-WETH-_-TPLQM-wBox-Tabletop_1333x.png?v=1784053137",
          "product_url": "/products/tabletopkit_weathered-wood_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_weathered-wood_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-WETH-TPLQM-wBox-Tabletop_05d87cf3-131d-448f-811e-a4f3eacea9af_1333x.png?v=1778527538",
          "product_url": "/products/tabletopkit_weathered-wood_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_weathered-wood_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-WETH-TPLQM-wBox-Tabletop_d41a26b8-9519-4109-873e-5306abf64165_1333x.png?v=1778527626",
          "product_url": "/products/tabletopkit_weathered-wood_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_weathered-wood_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-CHAR"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-CHAR-_-TPLQM-wBox-Tabletop_1333x.png?v=1784053272",
          "product_url": "/products/tabletopkit_charcoal_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_charcoal_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-CHAR-TPLQM-wBox-Tabletop_e65a6cc5-fd67-4132-b8ff-8240a66f688f_1333x.png?v=1778527949",
          "product_url": "/products/tabletopkit_charcoal_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_charcoal_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-CHAR-TPLQM-wBox-Tabletop_97a28f45-505f-40f3-800a-1e00f398ea65_1333x.png?v=1778528037",
          "product_url": "/products/tabletopkit_charcoal_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_charcoal_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-VCHY"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-CHRY-_-TPLQM-wBox-Tabletop_1333x.png?v=1784053410",
          "product_url": "/products/tabletopkit_vintage-cherry_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_vintage-cherry_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-CHRY-TPLQM-wBox-Tabletop_f2e8ab58-177f-42b0-be33-962ae74d8b76_1333x.png?v=1778528262",
          "product_url": "/products/tabletopkit_vintage-cherry_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_vintage-cherry_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-CHRY-TPLQM-wBox-Tabletop_873d023a-a4f9-4451-b5bf-9129a5c30b62_1333x.png?v=1778528452",
          "product_url": "/products/tabletopkit_vintage-cherry_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_vintage-cherry_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-CBLK"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-CBLK-_-TPLQM-wBox-Tabletop_1333x.png?v=1784053587",
          "product_url": "/products/tabletopkit_classic-black_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_classic-black_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-CBLK-TPLQM-wBox-Tabletop_4c003bdc-4612-4b12-91dd-c227fabaaa97_1333x.png?v=1778528718",
          "product_url": "/products/tabletopkit_classic-black_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_classic-black_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-CBLK-TPLQM-wBox-Tabletop_1bdc2656-9608-49a4-afca-6a845fbb89b9_1333x.png?v=1778528825",
          "product_url": "/products/tabletopkit_classic-black_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_classic-black_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-JAVA"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-JAVA-_-TPLQM-wBox-Tabletop_1333x.png?v=1784053724",
          "product_url": "/products/tabletopkit_java_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_java_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-JAVA-TPLQM-wBox-Tabletop_70a0106c-980e-4064-ab0d-674f282f96a5_1333x.png?v=1778529027",
          "product_url": "/products/tabletopkit_java_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_java_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-JAVA-TPLQM-wBox-Tabletop_2fbd7be8-eff7-4a51-81a6-404c36aebaf1_1333x.png?v=1778529124",
          "product_url": "/products/tabletopkit_java_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_java_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-RMGY"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-RMGY-_-TPLQM-wBox-Tabletop_1333x.png?v=1784053827",
          "product_url": "/products/tabletopkit_red-mahogany_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_red-mahogany_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-RMGY-TPLQM-wBox-Tabletop_0c559f8b-4265-4fc9-81fb-85c440f58569_1333x.png?v=1778529589",
          "product_url": "/products/tabletopkit_red-mahogany_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_red-mahogany_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-RMGY-TPLQM-wBox-Tabletop_354387b3-a866-4dde-bea4-d68e436cc3f9_1333x.png?v=1778529705",
          "product_url": "/products/tabletopkit_red-mahogany_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_red-mahogany_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-CEDR"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-CEDR-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054096",
          "product_url": "/products/tabletopkit_cedar_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_cedar_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-CEDR-TPLQM-wBox-Tabletop_72adac4a-d5ae-456a-948f-31d56089eb9d_1333x.png?v=1778529924",
          "product_url": "/products/tabletopkit_cedar_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_cedar_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-CEDR-TPLQM-wBox-Tabletop_3612cc0a-0a1c-4592-9f4a-8751758959d7_1333x.png?v=1778530050",
          "product_url": "/products/tabletopkit_cedar_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_cedar_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-OOAK"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-OOAK-_-TPLQM-wBox-Tabletop_1333x.png?v=1784054229",
          "product_url": "/products/tabletopkit_old-oak_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_old-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-OOAK-TPLQM-wBox-Tabletop_251edbfd-a0be-44bf-ac0e-866a67df7edf_1333x.png?v=1778530573",
          "product_url": "/products/tabletopkit_old-oak_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_old-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-OOAK-TPLQM-wBox-Tabletop_dacb12ff-60c6-40bd-bcb8-1084a1b5302c_1333x.png?v=1778530475",
          "product_url": "/products/tabletopkit_old-oak_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_old-oak_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-WNKttop-PECA"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "truncate_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12,
    "match_settings_preset_key": "Sizes-WNKttop-SBCH"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Tabletop Kit",
          "alt": "Small Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK08-PECA-TPLQM-wBox-Tabletop_b843de5f-5b2e-40a6-83c1-0f6cbb8b0f3b_1333x.png?v=1778530683",
          "product_url": "/products/tabletopkit_pecan_s_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_pecan_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Tabletop Kit",
          "alt": "Medium Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK16-PECA-TPLQM-wBox-Tabletop_173f4470-8da2-448a-81f7-60e9cbe74eef_1333x.png?v=1778530765",
          "product_url": "/products/tabletopkit_pecan_m_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_pecan_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Tabletop Kit",
          "alt": "Large Tabletop Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "https://retique.com/cdn/shop/files/WNK32-PECA-TPLQM-wBox-Tabletop_12e12332-52f1-4879-baf5-952253f9d043_1333x.png?v=1778530845",
          "product_url": "/products/tabletopkit_pecan_l_tripletique",
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/tabletopkit_pecan_l_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3>Estimated Coverage by Size</h3>",
      "subheading": "<p><strong>Small Tabletop Kit — 25 square feet</strong><br>8oz Wood'n Primer · 8oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Medium Tabletop Kit — 50 square feet</strong><br>16oz Wood'n Primer · 16oz Wood'n Stain · 8oz Gel Stain Alternative</p><p><strong>Large Tabletop Kit — 100 square feet</strong><br>32oz Wood'n Primer · 32oz Wood'n Stain · 8oz Gel Stain Alternative</p><p>All sizes include graining tools, an application brush, a staining sponge, and Tripletique® topcoat in your selected sheen.</p>",
      "heading_justify": "center",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
